import React, { useState, useEffect } from 'react';
import { Heart, Mail, Phone, Instagram, ArrowUp } from 'lucide-react';
import { useModal } from '../../contexts/ModalContext';

const Footer: React.FC = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showCopied, setShowCopied] = useState(false);
  const { isModalOpen } = useModal();

  useEffect(() => {
    const handleScroll = () => {
      // Buscar la sección de experiencias (Testimonials)
      const experienciasSection = document.querySelector('section.bg-contessa-100');

      if (experienciasSection) {
        const rect = experienciasSection.getBoundingClientRect();
        // Mostrar el botón cuando la sección de experiencias esté visible en el viewport
        setShowScrollTop(rect.top <= window.innerHeight && rect.bottom >= 0);
      } else {
        // Fallback: mostrar después de 400px si no se encuentra la sección
        setShowScrollTop(window.scrollY > 400);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Ejecutar al cargar para verificar posición inicial
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <footer className="bg-contessa-800 text-white relative overflow-hidden">
        {/* Background Pattern */}
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `radial-gradient(circle, rgba(255,255,255,0.05) 1px, transparent 1px)`,
            backgroundSize: '40px 40px'
          }}
        />
        
        <div className="container mx-auto px-4 md:px-6 py-12 relative z-10">


          {/* Main Content */}
          <div className="max-w-4xl mx-auto text-center mb-8">
            <h4 className="text-2xl font-serif font-bold mb-4 flex items-center justify-center">
              <Heart size={24} className="text-contessa-400 mr-2" />
              Los ciclos de Marha
            </h4>
            <p className="text-contessa-100 mb-8 text-md">
              Acompañamiento profesional y humano en embarazo, nacimiento y puerperio para vivir esta 
              etapa con plenitud y seguridad.
            </p>
          </div>

          {/* Social Media */}
          <div className="max-w-3xl mx-auto mb-8">
            <div className="text-center">
              <div className="flex space-x-4 justify-center">
                <a 
                  href="https://www.instagram.com/losciclosdemarha/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-contessa-400 hover:bg-contessa-700 p-3 rounded-full transition-all hover:scale-110"
                  aria-label="Instagram"
                >
                  <Instagram size={24} className="text-contessa-100" />
                </a>
                <a 
                  href="https://wa.link/9q8osz" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-contessa-400 hover:bg-contessa-700 p-3 rounded-full transition-all hover:scale-110"
                  aria-label="WhatsApp"
                >
                  <Phone size={24} className="text-contessa-100" />
                </a>
                <div className="relative">
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText('losciclosdemarha@gmail.com');
                      setShowCopied(true);
                      setTimeout(() => setShowCopied(false), 2000);
                    }}
                    className="bg-contessa-400 hover:bg-contessa-700 p-3 rounded-full transition-all hover:scale-110"
                    aria-label="Copiar email"
                    title="Copiar email"
                  >
                    <Mail size={24} className="text-contessa-100" />
                  </button>
                  {/* Tooltip "Copiado" */}
                  {showCopied && (
                    <div className="absolute left-1/2 transform -translate-x-1/2 bg-contessa-600 text-white px-3 py-1 rounded-md text-sm whitespace-nowrap shadow-lg">
                      ¡Copiado!
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          
          {/* Copyright */}
          <div className="border-t border-contessa-900 pt-6 text-center text-contessa-300 text-sm">
            <p>
              Desarrollado por{' '}
              <a 
                href="https://rodrip.online" 
                target="_blank" 
                rel="noopener noreferrer" 
                title="Portafolio de RodriP." 
                className="text-white hover:text-white transition-colors"
              >
                <span className="text-lg font-semibold tracking-tighter">Rodri<span className="text-emerald-500">P</span></span>
              </a>
            </p>
          </div>
        </div>
      </footer>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-8 right-8 bg-contessa-600 hover:bg-contessa-500 text-white p-4 rounded-full shadow-lg transition-all duration-300 z-50 ${
          showScrollTop && !isModalOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16 pointer-events-none'
        }`}
        aria-label="Volver arriba"
      >
        <ArrowUp size={24} />
      </button>
    </>
  );
}; 

export default Footer;